import React, { useEffect, useRef, useState } from 'react';
import './styles.scss';

interface BroadcastDetail {
  text: string;
  durationMs: number;
}

// Full-width banner shown to EVERY player when an admin uses the "Message à
// tous les joueurs" form (features/adminPanel's status tab) - see
// adminSystem.ts's "broadcastMessage" action / adminMenuService.ts's
// "adminBroadcast" relay. Distinct from Toast: this is meant to be
// impossible to miss (server announcements, restart warnings), not an
// ephemeral corner notification, and stays up for an admin-chosen duration
// with a visible countdown rather than a fixed 4s.
const AdminBroadcast: React.FC = () => {
  const [detail, setDetail] = useState<BroadcastDetail | null>(null);
  const [remainingMs, setRemainingMs] = useState(0);
  const hideTimer = useRef<ReturnType<typeof setTimeout>>();
  const tickTimer = useRef<ReturnType<typeof setInterval>>();

  useEffect(() => {
    const handler = (e: Event) => {
      const d = (e as CustomEvent<BroadcastDetail>).detail;
      if (!d?.text) return;

      clearTimeout(hideTimer.current);
      clearInterval(tickTimer.current);

      setDetail(d);
      setRemainingMs(d.durationMs);

      const startedAt = Date.now();
      tickTimer.current = setInterval(() => {
        setRemainingMs(Math.max(0, d.durationMs - (Date.now() - startedAt)));
      }, 200);
      hideTimer.current = setTimeout(() => {
        setDetail(null);
        clearInterval(tickTimer.current);
      }, d.durationMs);
    };

    window.addEventListener('skymp5-client:adminBroadcast', handler);
    return () => {
      window.removeEventListener('skymp5-client:adminBroadcast', handler);
      clearTimeout(hideTimer.current);
      clearInterval(tickTimer.current);
    };
  }, []);

  if (!detail) return null;

  return (
    <div className="admin-broadcast">
      <div className="admin-broadcast__box">
        <span className="admin-broadcast__text">{detail.text}</span>
        <span className="admin-broadcast__timer">{Math.ceil(remainingMs / 1000)}s</span>
      </div>
    </div>
  );
};

export default AdminBroadcast;
